module.exports = __webpack_public_path__ + "media/16.46151d02.mp3";